import { t as translateDate } from './translate-date.js';
import './index2.js';

/**
 * ** Vertical Booking **
 *
 * @exports bs_91
 * @category engines
 */
function factory({ window, document, thn }) {
    const engine = {};
    /**
       * @memberOf module:bs_91
       * @see {@link language_check}
       *
       * @param {object} ctx - The context object.
       */
    engine.languageCheck = function languageCheck(ctx) {
        return new Promise(function (resolve, reject) {
            let lang;
            const levniLangs = {
                1: 'en',
                2: 'tr',
                3: 'es',
                4: 'fr',
            };
            function normalize(langEl) {
                if (!langEl || langEl.length > 3) {
                    return undefined;
                }
                if (langEl.length === 3) {
                    langEl = langEl.slice(0, -1);
                }
                const langDictionary = {
                    tu: 'tr',
                    du: 'nl',
                };
                return langDictionary[langEl] || langEl;
            }
            if ([1029546, 1038706, 1038708].includes(thn.data.propertyId) && (thn.data.pageName === 'User Register Page' || 'Booking Confirmed')) {
                lang = normalize(document.querySelector('#summary-body')?.getAttribute('class')?.slice(5))
                    || normalize(document.body.getAttribute('class')?.slice(5));
            }
            if (thn.data.accountUserId === 1033811) {
                resolve('es');
                return;
            }
            if (thn.data.accountUserId === 1041839) { // some properties of this UID have different class name for the querySelectors
                if (document.querySelector('.language-block')) {
                    lang = document.querySelector('.language-block')?.innerText.toLocaleLowerCase() || document.querySelector('html')?.lang;
                }
                else if (document.querySelector('.dropdown')) {
                    lang = document.querySelector('.dropdown')?.innerText.toLocaleLowerCase() || document.querySelector('html')?.lang;
                }
                else if (document.querySelector('.currentLang')) {
                    lang = document.querySelector('.currentLang')?.innerText.toLocaleLowerCase() || document.querySelector('html')?.lang;
                }
                else if (document.querySelector('.spento')?.lastChild?.src.substring(53, 56)) {
                    lang = normalize(document.querySelector('.spento')?.lastChild?.src.substring(53, 56));
                }
            }
            if (thn.data.accountUserId === 1037186
                && !window.location.hostname.match(/reservations/)) {
                lang = (document.querySelector('[name=language]') || {}).getAttribute('content');
            }
            else if (thn.parseUrlParameter('LanguageID')) {
                lang = thn.parseUrlParameter('LanguageID');
                lang = lang && normalize(levniLangs[lang]);
            }
            else if (thn.parseUrlParameter('lingua_int') && thn.data.accountUserId === 1042173) {
                lang = thn.parseUrlParameter('lingua_int');
                lang = lang && normalize(lang.substr(0, 2));
            }
            if (lang && ctx.langs.test(lang)) {
                resolve(lang);
                return;
            }
            thn.domReady().then(function () {
                lang = document.querySelector('#language-list > .selected')?.getAttribute('data-language')?.substr(0, 2);
                lang = lang && normalize(lang);
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                const bookingEngineLang = window.b_params?.lingua_int || document.querySelector('[name=lingua_int]')?.value;
                lang = window.location.hostname.match(/reservations/) ? bookingEngineLang : document.querySelector('.currentLang')?.textContent || document.documentElement.lang;
                lang = lang && lang.substr(0, 2);
                if (lang && ctx.langs.test(lang)) {
                    resolve(lang);
                    return;
                }
                if (thn.data.propertyId === 1039114 && window.location.host.match('www.hoteldondiego.com')) {
                    lang = document.body?.className;
                    resolve(lang);
                    return;
                }
                resolve('en');
            });
        });
    };
    /**
       * @memberOf module:bs_91
       * @see {@link generate_search_url}
       *
       * @param {object} ctx - The context object.
       */
    engine.generateSearchUrl = function generateSearchUrl(ctx) {
        const url = new URL(ctx.baseUrl);
        const validUrl = !!((url.host.match(/reservations.verticalbooking/) || url.host.match(/reservation\.calista\.com\.tr/)) && (url.pathname.match(/risultato.html/) || url.search.match(/id_albergo/)));
        const langDictionary = {
            en: 'eng',
            it: 'ita',
            de: 'deu',
            fr: 'fra',
            es: 'esp',
            ru: 'rus',
            nd: 'dut',
            tr: 'tur',
            pt: 'por',
            fi: 'fin',
            zh: 'chi',
            ko: 'kor',
            ja: 'jpn',
            th: 'tha',
            no: 'nor',
            sv: 'sve',
        };
        if (validUrl) {
            // https://reservations.verticalbooking.com/reservations/risultato.html?headvar=ok&lingua_int=eng&id_albergo=10032&dc=639&id_stile=15331&id_prodotto_sel=&gg=17&mm=8&aa=2022&notti_1=4&tot_adulti=2&tot_bambini=0&tot_camere=1&generic_codice=senior#_ga=2.21359485.730844840.1658749797-2077553198.1658749797
            url.searchParams.set('lingua_int', '[language]');
            url.searchParams.set('gg', '[arrivalDay]');
            url.searchParams.set('mm', '[arrivalMonth]');
            url.searchParams.set('aa', '[arrivalYear]');
            url.searchParams.set('tot_camere', '[rooms]');
            url.searchParams.set('adulti', '[adults]');
            url.searchParams.set('notti_1', '[nights]');
            url.searchParams.set('generic_codice', '');
            url.searchParams.set('ggf', '[departureDay]');
            url.searchParams.set('mmf', '[departureMonth]');
            url.searchParams.set('aaf', '[departureYear]');
            // export into ctx.new_url
            ctx.newUrl = url.toString();
            ctx.newData.language = langDictionary[ctx.newData?.language] || 'eng';
            const dateBegin = ctx.newData?.dateBegin || ctx.data?.dateBegin;
            const dateEnd = ctx.newData?.dateEnd || ctx.data?.dateEnd;
            if (dateBegin && dateEnd) {
                ctx.newData.nights = thn.daysBetween(dateBegin, dateEnd);
            }
            if (dateBegin) {
                const dateBeginParts = dateBegin?.split(/[-/\\]/);
                ctx.newData.arrivalDay = dateBeginParts[2];
                ctx.newData.arrivalMonth = dateBeginParts[1];
                ctx.newData.arrivalYear = dateBeginParts[0];
            }
            if (dateEnd) {
                const dateEndParts = dateEnd?.split(/[-/\\]/);
                ctx.newData.departureDay = dateEndParts[2];
                ctx.newData.departureMonth = dateEndParts[1];
                ctx.newData.departureYear = dateEndParts[0];
            }
        }
        else {
            // This is not a valid URL
            ctx.newUrl = '';
        }
        return ctx;
    };
    /**
       * @memberOf module:bs_91
       * @see {@link prestart}
       *
       * @param {object} ctx - The context object.
       */
    engine.boot = function boot() {
        const container = document.documentElement;
        if (!container) {
            return;
        }
        const langObserver = thn.debounce(thn.languageCheck, 200);
        thn.observeDom(container, langObserver, {
            childList: true,
            attributes: true,
        });
        thn.shutdown(() => {
            langObserver.cancel();
            thn.stopObserveDom(container, langObserver);
        });
    };
    /**
       * @memberOf module:bs_91
       * @see {@link onStateChange}
       *
       * @param {object} ctx - The context object.
       */
    engine.onStateChange = function onStateChange(ctx) {
        setTimeout(thn.pageCheck, 400);
    };
    /**
       * @memberOf module:bs_91
       * @this thn.widgets.price
       * @see {@link Price#observe_dom}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceObserveDom = function priceObserveDom(ctx) {
        const loader = document.querySelector('#blocco_scheda > div.caricamento_animazione > div');
        if (!!loader && !thn.letsbookLoaderUpdate) {
            thn.letsbookLoaderUpdate = thn.debounce(function thnLetsbookLoaderUpdate() {
                if (!thn.isVisible(loader)) {
                    ctx.widget.update();
                }
            }, 600);
            thn.observeDom(loader, thn.letsbookLoaderUpdate, {
                childList: false,
                subtree: false,
                characterData: false,
                attributes: true,
                attributeFilter: ['style', 'class'],
            });
            thn.pageUnload(function () {
                thn.stopObserveDom(loader, thn.letsbookLoaderUpdate);
                delete thn.letsbookLoaderUpdate;
            });
        }
    };
    /**
       * @memberOf module:bs_91
       * @this thn.widgets.price
       * @see {@link Price#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.priceParseData = function priceParseData(ctx) {
        const widgetData = {};
        /*
             * Dates were taken from 2 variables that contained unix time values.
             * That could change the dates depending from which country we were looking at from.
             * Changed the selector so we take the dates from the format ones that are visible in
             * the DOM.
             */
        const dataForm = document.querySelector('#form_selezione_prodotto_camera') || document.querySelector('#form_repost_valuta');
        const datesArray = dataForm && [...dataForm].filter((dateEl) => dateEl.attributes?.name.value.match(/aa|mm|gg/));
        const guestsArray = dataForm && [...dataForm].filter((guest) => guest.attributes?.name.value.match(/adulti1|bambini1/));
        if (datesArray.length === 6) {
            widgetData.dateBegin = `${datesArray[2].value}/${datesArray[1].value?.padStart(2, '0')}/${datesArray[0].value?.padStart(2, '0')}`;
            widgetData.dateEnd = `${datesArray[5].value}/${datesArray[4].value?.padStart(2, '0')}/${datesArray[3].value?.padStart(2, '0')}`;
        }
        else if (window.location.search.includes('gg')) {
            widgetData.dateBegin = thn.dateToString(`${thn.parseUrlParameter('aa')}/${thn.parseUrlParameter('mm')}/${thn.parseUrlParameter('gg')}`);
            widgetData.dateEnd = thn.dateToString(`${thn.parseUrlParameter('aaf')}/${thn.parseUrlParameter('mmf')}/${thn.parseUrlParameter('ggf')}`);
        }
        let nights;
        widgetData.adults = window.b_params?.tot_adulti || thn.parseNumber(guestsArray[0]?.value) || 2;
        widgetData.children = window.b_params?.tot_bambini || thn.parseNumber(guestsArray[1]?.value) || 0;
        widgetData.guests = widgetData.adults + widgetData.children;
        widgetData.currency = thn.parseCurrency(document.querySelector('span.tariffa, .starting-from-room-rate')?.childNodes[2]?.textContent.trim()) || thn.parseCurrency(document.querySelector('.starting-from-room-rate')?.textContent) || 'EUR';
        const prices = [...document.querySelectorAll('.price.buona_tariffa, .best_price_at_all, .starting-from-room-rate')].map((price) => thn.parseNumber(price?.textContent.trim()));
        if (widgetData.dateBegin && widgetData.dateEnd) {
            nights = thn.daysBetween(widgetData.dateBegin, widgetData.dateEnd);
        }
        if (!thn.empty(prices) && nights) {
            const price = Math.min(...prices);
            widgetData.price = price / nights;
            widgetData.set = true;
        }
        else {
            widgetData.noRooms = true;
        }
        return widgetData;
    };
    /**
       * @memberOf module:bs_91
       * @this thn.widgets.booking
       * @see {@link Booking#set_data}
       *
       * @param {object} ctx - The context object.
       */
    engine.bookingParseData = function bookingParseData(ctx) {
        const widgetData = {};
        const $ = window.jQuery;
        const $dates = $('.summary_value_nights .value-data');
        if ($dates.length === 2) {
            widgetData.dateBegin = translateDate($dates.first().text().match(/\d+[\s\D]+\d+/)[0], thn.data.language);
            widgetData.dateEnd = translateDate($dates.last().text().match(/\d+[\s\D]+\d+/)[0], thn.data.language);
        }
        const price = $('.summary_value_total_room_rate').text();
        if (price) {
            widgetData.price = thn.parseNumber(price);
            widgetData.currency = price.match(/[^\d\s.,]+/)[0];
        }
        widgetData.bookingId = thn.parseUrlParameter('ultimo_codice');
        if (!widgetData.bookingId && $) {
            widgetData.bookingId = $('[data-codice_prenotazione]').attr('data-codice_prenotazione');
        }
        return widgetData;
    };
    return engine;
}

export { factory };
